import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { Button } from "../../components/Button";
import config from "../../config";
import { useUserService } from "../../services/user.service";
import { toast } from "react-toastify";

function DeleteProfile() {
  const navigate = useNavigate();
  const { createSupportTicket } = useUserService();
  const [feedback, setFeedback] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleSendFeedback = async () => {
    if (isSending) return;
    if (!feedback.trim()) {
      alert("Пожалуйста, опишите ситуацию");
      return;
    }

    setIsSending(true);
    try {
      await createSupportTicket(
        "Обратная связь перед удалением аккаунта",
        feedback
      );
      toast.success('Ваше сообщение отправлено!');
      setFeedback("");
    } catch (error) {
      console.error("Error sending feedback:", error);
      toast.error("Произошла ошибка при отправке сообщения. Попробуйте еще раз.")
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="w-[100vw] h-[100%] flex flex-col items-center justify-start font-raleway overflow-scroll">
      <div
        className="flex items-center justify-center relative text-white text-[24px] w-full
            border-b border-[#233636] pb-[26px] pt-4"
      >
        <img
          alt="Назад"
          src="/icons/Button-back.svg"
          onClick={() => {
            navigate(-1);
          }}
          className="absolute top-[32px] left-[16px] w-[44px] h-[44px]"
        />
        <p className="mt-5">Удаление аккаунта</p>
      </div>
      <div className="w-[343px] text-[20px] text-white">
        <p className="pt-[26px] pb-[15px]">
          Удаление аккаунта приведёт к безвозвратной потере ваших данных в этом
          приложении.
        </p>
        <p>
          Возможно, что-то вас огорчило, но нет неразрешимых проблем. Напишите,
          пожалуйста, что вас расстроило, и мы приложим все усилия, чтобы вам
          помочь в кратчайшие сроки!
        </p>
        <textarea
          className="w-full bg-[#022424] rounded-[8px] border border-[#233636] text-[18px] pl-[10px] pt-[7px] h-[240px] mt-[10px]"
          placeholder="Опишите сложившуюся ситуацию"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          maxLength={200}
        />
      </div>

      <div className="text-black pt-[50px] pb-[30px] flex flex-col items-center justify-center">
        <div onClick={handleSendFeedback}>
          <Button disabled={isSending}>
            {isSending ? "Отправка..." : "Отправить"}
          </Button>
        </div>
        <p
          className="text-[18px] text-white opacity-50 pt-[15px]"
          onClick={() => {
            navigate(config.ROUTES.PROFILE.CONFIRM_DELETE);
          }}
        >
          Всё равно хочу удалить
        </p>
      </div>
    </div>
  );
}

export default DeleteProfile;
